import { useEffect, useState } from "react";
import { AngleUpIcon } from "assets/svgs";
import { useOutsideClick } from "hooks";
import { CustomInput } from "../input";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";
import { shortenStringByddingDots } from "utils/helpers";
import styles from "./styles.module.css";

// IT will return an object on onChange

export function CustomSelectV1({
  onChange,
  options = [],
  placeholder,
  value,
}: any) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [searchTest, setSearchText] = useState<string>("");
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const { isDarkMode } = useAppSelector(userSettingState);
  const ref = useOutsideClick(() => {
    setIsOpen(false);
  });

  useEffect(() => {
    const option = options.find((item: any) => item.label === value);
    setSelectedOption(option);
  }, [value]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    onChange(option);
    setIsOpen(false);
  };

  const filteredOptions = options?.filter((item: any) =>
    item?.label?.toLowerCase().includes(searchTest)
  );

  const title = selectedOption?.label ? { title: selectedOption.label } : {};

  return (
    <div
      className={`${styles.selectMain} ${isDarkMode ? styles.darkMode : ""}`}
      ref={ref}
    >
      <button
        type="button"
        className={`${styles.selectBtn} ${
          !selectedOption && styles.placeholder
        }`}
        onClick={toggleDropdown}
        {...title}
      >
        {selectedOption
          ? shortenStringByddingDots(selectedOption?.label, 26)
          : placeholder}
        <span className={isOpen ? styles.angleDownIcon : styles.angleUpIcon}>
          <AngleUpIcon />
        </span>
      </button>

      {isOpen && (
        <div className={styles.optionsWrapper}>
          <CustomInput
            type="text"
            onChange={(value: any) => setSearchText(value?.toLowerCase())}
            placeholder="Search..."
          />
          <ul>
            {filteredOptions.map((option: any) => (
              <li
                key={option.value}
                className={`${styles.option} ${
                  selectedOption && selectedOption.value === option.value
                    ? styles.active
                    : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
